module.exports = __webpack_public_path__ + "img/body-balance.8ff3326b.jpg";